/* @flow */
/* eslint-disable camelcase */
/* eslint-disable babel/no-invalid-this */
import type { PercentInteger } from "nexia_mobile/api/types";
import type { FanFeature } from "./types";

export default function Fan(feature: FanFeature) {
  let fanSpeedAction = feature.actions.set_speed;

  this.getFanSpeedLabel = (speed: PercentInteger = feature.speed) => {
    let roundedSpeed = Math.round(speed);
    switch (false) {
      case roundedSpeed !== 0:
        return "Off";
      case roundedSpeed > 33:
        return "Low";
      case roundedSpeed > 67:
        return "Medium";
      default:
        return "High";
    }
  };

  this.setFanSpeed = (speed: PercentInteger) => {
    return this.executeDeviceAction(
      fanSpeedAction,
      {
        level: this.getFanSpeedLabel(speed),
      },
      {
        updateModelWithResponse: false,
      }
    );
  };

  return {
    fan_speed: feature.speed,
    fan_speed_increment: feature.speed_increment,
    status: feature.status,
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/fan.js